import { CompanyResponse } from "@key-telematics/fleet-api-client";
import { TranslateService } from "@ngx-translate/core";


export function getPasswordRequirementText(i18n: TranslateService, company: CompanyResponse): string[] {
    const result = [];
    if (company.passwordPolicy?.passwordLength) {
        result.push(i18n.instant('ADMIN.EDITORS.USER.DETAILS.FIELDS.PASSWORD_LENGTH', { length: company.passwordPolicy?.passwordLength }));
    }
    if (company.passwordPolicy?.passwordComplexity?.alphaNumerical) {
        result.push(i18n.instant('ADMIN.EDITORS.USER.DETAILS.FIELDS.PASSWORD_ALPHANUMERIC'));
    }
    if (company.passwordPolicy?.passwordComplexity?.mixedCase) {
        result.push(i18n.instant('ADMIN.EDITORS.USER.DETAILS.FIELDS.PASSWORD_MIXEDCASE'));
    }
    if (company.passwordPolicy?.passwordComplexity?.specialCharacters) {
        result.push(i18n.instant('ADMIN.EDITORS.USER.DETAILS.FIELDS.PASSWORD_SYMBOLS'));
    }
    return result;
}